import { useMemo } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { SubmissionModuleState } from '../fsm/SubmissionModuleState';

const MODULE_STATE_FIXTURE_KEY = 'module-state-fixture';

// Salva nel localStorage uno stato fittizio del modulo
export function useModuleStateFixture(
  moduleId: string | null | undefined = '<undefined>',
) {
  const moduleKey = useMemo(
    () => `${MODULE_STATE_FIXTURE_KEY}-${moduleId}`,
    [moduleId],
  );
  const [value, setValue] = useLocalStorage(
    moduleKey,
    SubmissionModuleState.Compilation,
  );

  return {
    moduleState: value,
    setModuleStateFixture: setValue,
  };
}
